import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1d0afae3")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "search-download" }
const _hoisted_3 = { class: "checkbox-filters" }
const _hoisted_4 = { class: "p-input-icon-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = { class: "field-checkbox" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "filter1"
}, "Publicadas", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "filter2"
}, "No publicadas", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "filter3"
}, "Finalizadas", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "filter4"
}, "Todas", -1)
const _hoisted_12 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_13 = {
  class: "card-container",
  ref: "scrollComponent"
}
const _hoisted_14 = {
  key: 0,
  class: "noOffers"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle noOffersIcon" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "fontWeight500" }, "No pudimos encontrar ofertas laborales", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Prueba usando otras palabras.", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "dialTitle" }, "¿Quieres dejar de publicar esta oferta laboral?", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Si lo haces, ya no será visible para estudiantes ni graduados. No se borrará y podrás volver a publicarla cuando quieras.", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_jobOfferCard = _resolveComponent("jobOfferCard")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_InputText, {
            placeholder: "Buscar ofertas laborales",
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.search = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Checkbox, {
              class: "checkbox",
              id: "filter1",
              name: "filter",
              value: "published",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_8,
            _createVNode(_component_Checkbox, {
              class: "checkbox",
              id: "filter2",
              name: "filter",
              value: "notPublished",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_9,
            _createVNode(_component_Checkbox, {
              class: "checkbox",
              id: "filter3",
              name: "filter",
              value: "finished",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_10,
            _createVNode(_component_Checkbox, {
              class: "checkbox",
              id: "filter4",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleAllFilters())),
              name: "filter",
              value: "all",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_11,
            _createVNode(_component_Button, {
              label: "Borrar filtros",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clear())),
              class: "p-button-link clearFilters"
            })
          ])
        ])
      ]),
      _createVNode(_component_Button, {
        icon: "pi pi-download",
        label: "Reporte",
        class: "download-button",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createExcel()))
      }),
      _withDirectives(_createVNode(_component_DataTable, {
        value: _ctx.jobOffersList,
        ref: "jobOffersTable",
        responsiveLayout: "scroll",
        exportFilename: "Información de ofertas laborales"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-download",
            label: "Descargar",
            class: "p-button-outlined p-button-help",
            onExport: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportCSV($event)))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_Column, {
              header: "Nombre del puesto",
              field: "name"
            }),
            _createVNode(_component_Column, {
              header: "Modalidad",
              field: "modality"
            }),
            _createVNode(_component_Column, {
              header: "Cantidad de puestos a cubrir",
              sortable: "",
              field: "quantityEmployees"
            }),
            _createVNode(_component_Column, {
              header: "Ubicación de trabajo",
              sortable: "",
              field: "location"
            }),
            _createVNode(_component_Column, {
              header: "Área de trabajo",
              sortable: "",
              field: "area"
            }),
            _createVNode(_component_Column, {
              header: "Jerarquía",
              sortable: "",
              field: "hierarchy"
            }),
            _createVNode(_component_Column, {
              header: "Link de búsqueda",
              sortable: "",
              field: "link"
            }),
            _createVNode(_component_Column, {
              header: "Estado",
              sortable: "",
              field: "state"
            })
          ])
        ]),
        _: 1
      }, 8, ["value"]), [
        [_vShow, false]
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_BrainSpinner)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      (!_ctx.jobOffers.length && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobOffers, (jobOffer) => {
        return (_openBlock(), _createBlock(_component_jobOfferCard, {
          jobOfferCard: jobOffer,
          showImage: _ctx.showImage,
          key: jobOffer._id,
          onHandleStatusChange: _ctx.handleStatusChange
        }, null, 8, ["jobOfferCard", "showImage", "onHandleStatusChange"]))
      }), 128)),
      _createVNode(_component_Dialog, {
        visible: _ctx.displayModal,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.displayModal = $event)),
        draggable: false,
        style: {width: '50vw'},
        modal: true
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-arrow-left",
            onClick: _ctx.closeModal,
            class: "p-button-rounded p-button-text p-button-plain"
          }, null, 8, ["onClick"]),
          _hoisted_19
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancelar",
            onClick: _ctx.closeModal,
            class: "p-button-text"
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "back-saveChanges",
            label: "Aceptar",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.unPublish()))
          })
        ]),
        default: _withCtx(() => [
          _hoisted_20
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512)
  ]))
}